export const KeybackupTestIds = {
  verifySuccess: 'verify_success',
  initialVerifySuccess: 'initial_success',
  verifyFailure: 'verify_failure',
  savedPassword: 'saved_password',
  btnCopypassword: 'btn_copypassword',
  chatNavigation: 'chat_navigation',
  passwordSuggestion: 'password_suggestion',
  fieldInputVerificationpassword: 'field_input_verificationpassword',
  passwordVisibilityToggle: 'password_visibility_toggle',
  btnSubmitVerification: 'btn_submit_verification',
  btnSkipverification: 'btn_skipverification',
  confirmBackupkey: 'confirm_backupkey',
  confirmSkipBackupkey: 'confirm_skip_backupkey',
  passwordError: 'password_error'
} as const;
